(function () {
  'use strict';

  // ==========================================================================
  // VO / bcpo suppression — PILOT PRODUCT ONLY
  // ==========================================================================
  // The VO Product Options app is installed as a *global* theme app embed plus
  // an app block inside the product section, so it cannot be turned off for a
  // single product from the theme side. This removes its rendered UI and, more
  // importantly, its line-item property inputs, so the pilot product can never
  // post two competing sets of personalization data.
  //
  // Scoped hard: everything below is a no-op unless the enclosing product form
  // carries [data-cc-pilot], which only the pilot product's form does.
  // Anything inside [data-cc-atelier-pickers] is never touched.
  // ==========================================================================

  var form = document.querySelector('form[data-cc-pilot]');
  if (!form) return;

  // Containers VO renders its options into. bcpo uses #bcpo as its root and
  // prefixes its generated classes with "bcpo-".
  var CONTAINER_SELECTOR = '#bcpo, .bcpo-wrapper, [id^="bcpo-"], [class^="bcpo-"], [class*=" bcpo-"]';

  function isOurs(el) {
    return !!el.closest('[data-cc-atelier-pickers]');
  }

  function hideContainers(scope) {
    var nodes = scope.querySelectorAll(CONTAINER_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (isOurs(el)) continue;
      if (el.dataset.ccSuppressed) continue;
      el.dataset.ccSuppressed = '1';
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
    }
  }

  // Strip VO's line-item property inputs so they cannot post alongside ours.
  // Hiding is not enough: a hidden input still serializes into FormData.
  // Only inputs that live inside a VO container are removed — our own
  // properties[...] inputs are inside [data-cc-atelier-pickers] and are skipped
  // both by the container test and by the isOurs() guard.
  function stripInputs(scope) {
    var fields = scope.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (isOurs(field)) continue;
      if (!field.closest(CONTAINER_SELECTOR)) continue;
      field.parentNode.removeChild(field);
    }
  }

  function sweep() {
    hideContainers(document);
    stripInputs(document);
  }

  sweep();

  // VO injects asynchronously after its app embed script loads, and re-injects
  // on variant change, so a one-shot sweep is not enough.
  var observer = new MutationObserver(function () { sweep(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Final guarantee: sweep once more the moment the pilot form is submitted,
  // so anything injected between the last mutation and the click is gone
  // before Pipeline serializes the form.
  form.addEventListener('submit', sweep, true);
  var atc = form.querySelector('[data-add-to-cart]');
  if (atc) atc.addEventListener('click', sweep, true);
})();
